import { ExportToCsv } from 'export-to-csv';
import firebase from 'firebase'


function getDeliveryMarginForOrder(order,defaultDeliveryCharge){
    try{
        if(order.deliveryBySalesperson ||  order.isAmendmentOrder) return 0
        
        var deliveryCharge = order.deliveryCharge
        deliveryCharge = deliveryCharge.trim()
        var deliveryMargin = 0
        if(order.marginDeliveryCharge && !isNaN(Number(order.marginDeliveryCharge))) {
            deliveryMargin = Number(order.marginDeliveryCharge)
        }
        else {
            if(isNaN(Number(order.deliveryCharge))) return 0
            deliveryCharge = Number(order.deliveryCharge)
            
            if(deliveryCharge > defaultDeliveryCharge) deliveryMargin = 0
            
            else deliveryMargin = deliveryCharge - defaultDeliveryCharge
        }
        deliveryMargin = deliveryMargin.toFixed(2)
        deliveryMargin = Number(deliveryMargin)
        return deliveryMargin
    }
    catch(e){
        //console.log(e)
        return 0
    }
}
function generateDeliveryMarginsByOrder(){
    var deliveryMarginsByOrder = {}
    var defaultDeliveryCharge = this.settings.defaultDeliveryCharge
    var orders = this.orders
    //var getDeliveryMarginForOrder = getDeliveryMarginForOrder
    
    console.log(this.settings.defaultDeliveryCharge)
    var orderedProducts = this.orderedProducts
    Object.keys(orders).map(function(key, index) {
        var o = orders[key]
        deliveryMarginsByOrder[o.id] = {deliveryMargin:0,numberOfProducts:0, deliveryMarginPerProduct:0}
        
        deliveryMarginsByOrder[o.id].deliveryMargin = getDeliveryMarginForOrder(o,defaultDeliveryCharge)
        //deliveryMarginsByOrder[o.id].deliveryMargin = !o.deliveryCharge || isNaN(Number(o.deliveryCharge)) ? 0 : Number(o.deliveryCharge)
        
        //deliveryMarginsByOrder[o.id].deliveryMargin = deliveryMarginsByOrder[o.id].deliveryMargin - defaultDeliveryCharge
        
        // override with manually set delivery chargge margin if exists
        
        //deliveryMarginsByOrder[o.id].deliveryMargin = deliveryMarginsByOrder[o.id].deliveryMargin.toFixed(2)
        //deliveryMarginsByOrder[o.id].deliveryMargin = Number(deliveryMarginsByOrder[o.id].deliveryMargin)
    })

    Object.keys(orderedProducts).forEach(function(opId, index) {
        var op = orderedProducts[opId]
        if(!deliveryMarginsByOrder[op.orderId]) return
        deliveryMarginsByOrder[op.orderId] ? deliveryMarginsByOrder[op.orderId].numberOfProducts += 1 : 0
        deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct = deliveryMarginsByOrder[op.orderId].deliveryMargin / deliveryMarginsByOrder[op.orderId].numberOfProducts
        deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct = deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct.toFixed(2)
        deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct = Number(deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct)
    })

    return deliveryMarginsByOrder
}

export default {
    getDeliveryMarginForOrder,
    generateDeliveryMarginsByOrder,
    getWeekString(weekNo,year){
        var d = new Date(year, 0, 1);
        
        var date = new Date(year, 0, 1);
        //var date = new Date(this.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        var firstWeek = 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                              - 3 + (week1.getDay() + 6) % 7) / 7);


        if(firstWeek != 1){
          d = new Date(d.setDate(d.getDate() + 7))
        }
        var daysSinceMonday = d.getDay()-1
        //console.log(daysSinceMonday)
        if(daysSinceMonday < 0) daysSinceMonday = 6
        d.setDate(d.getDate() - daysSinceMonday);
        d.setDate(d.getDate() + ( 7 * (weekNo-1)));
        
        var day = d.getDate() 
        var month = d.getMonth()+1
        var year = d.getFullYear()
        //var helsinkiDate = new tc.DateTime(year, month, day, 8, 0, 0, 0, tc.zone("Europe/Helsinki"));
        //var h = helsinkiDate.utcHour(); // 12
        //console.log(h)
        //d.setUTCHours(6,0,0,0)
        var s = day + '.' + month
        d.setDate(d.getDate() + 6) 
        s += '-' + d.getDate() + '.' + (d.getMonth()+1)
        return s
    },
    getWeek(date) {
        var dowOffset = 1
        var newYear = new Date(date.getFullYear(),0,1);
        var day = newYear.getDay() - dowOffset; //the day of week the year begins on
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((date.getTime() - newYear.getTime() - 
        (date.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
        var weeknum;
        //if the year starts before the middle of a week
        if(day < 4) {
          weeknum = Math.floor((daynum+day-1)/7) + 1;
          if(weeknum > 52) {
            nYear = new Date(date.getFullYear() + 1,0,1);
            nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /*if the next year starts before the middle of
              the week, it is week #1 of that year*/
            weeknum = nday < 4 ? 1 : 53;
          }
        }
        else {
          weeknum = Math.floor((daynum+day-1)/7);
        }
        return weeknum;
    },
    getFirstOfTheYearWeekNumber(year) {
        var date = new Date(year, 0, 1);
        //var date = new Date(this.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                              - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    // REMEMBER TO UPDATE ALSO IN FUNCTIONS IF UPDATING
    createVariationName:function(pv,dontAddPackeType){
        var text = ""
        var firstItem = true

        if(pv.colorCode){
            var colorName = ""
            if(pv.colorCode && this.settings.colors[pv.colorCode]) colorName = this.settings.colors[pv.colorCode].fi
            if(firstItem){ firstItem = false; text += colorName }
            else{text += " - " + colorName }
        }
        else if(pv.color && pv.color.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.color }
            else{text += " - " + pv.color }
        }
        if(pv.gender && pv.gender.trim() !== ""){
            if(firstItem){ firstItem = false; text += this.settings.genders[pv.gender].fi }
            else{text += " - " + this.settings.genders[pv.gender].fi }
        }
        if(pv.material && pv.material.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.material; }
            else{text += " - " + pv.material; }
        } 
        if(pv.size && pv.size.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.size }
            else{text += " - " + pv.size }
        } 
        if(pv.other && pv.other.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.other }
            else{text += " - " + pv.other }
        } 
        if(!dontAddPackeType){
            if(pv.packageType && pv.packageType !== ""){
                if(firstItem){ firstItem = false; text += this.settings.packageTypes[pv.packageType].fi }
                else{text += " - " + this.settings.packageTypes[pv.packageType].fi }
            } 
        }  
        return text
    },
    createVariationNameDataIncluded:function(pv,settings,dontAddPackeType){
        var text = ""
        var firstItem = true

        if(pv.colorCode){
            var colorName = ""
            if(pv.colorCode && settings.colors[pv.colorCode]) colorName = settings.colors[pv.colorCode].fi
            if(firstItem){ firstItem = false; text += colorName }
            else{text += " - " + colorName }
        }
        else if(pv.color && pv.color.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.color }
            else{text += " - " + pv.color }
        }
        if(pv.gender && pv.gender.trim() !== ""){
            if(firstItem){ firstItem = false; text += settings.genders[pv.gender].fi }
            else{text += " - " + settings.genders[pv.gender].fi }
        }
        if(pv.material && pv.material.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.material; }
            else{text += " - " + pv.material; }
        } 
        if(pv.size && pv.size.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.size }
            else{text += " - " + pv.size }
        } 
        if(pv.other && pv.other.trim() !== ""){
            if(firstItem){ firstItem = false; text += pv.other }
            else{text += " - " + pv.other }
        } 
        if(!dontAddPackeType){
            if(pv.packageType && pv.packageType !== ""){
                if(firstItem){ firstItem = false; text += settings.packageTypes[pv.packageType].fi }
                else{text += " - " + settings.packageTypes[pv.packageType].fi }
            } 
        }  
        return text
    },

    createVariationAvecorSku(pvId){
        var code = ""
        if(this.productVariations[pvId] && this.products[this.productVariations[pvId].productId]){
            if(this.products[this.productVariations[pvId].productId].avecorSku) code += this.products[this.productVariations[pvId].productId].avecorSku
            if(this.productVariations[pvId].colorCode) code += '-' + this.productVariations[pvId].colorCode  
            if(this.productVariations[pvId].size && this.settings.sizes.includes(this.productVariations[pvId].size.toUpperCase())) code += '-' + this.productVariations[pvId].size.toUpperCase() 
            if(this.productVariations[pvId].otherCode) code += '-' + this.productVariations[pvId].otherCode
        }
        return code
    },
    createVariationAvecorSkuDataIncluded(p,pv,settings){
        var code = ""
        if(pv && p){
            if(p.avecorSku) code += p.avecorSku
            if(pv.colorCode) code += '-' + pv.colorCode  
            if(pv.size && settings.sizes.includes(pv.size.toUpperCase())) code += '-' + pv.size.toUpperCase() 
            if(pv.otherCode) code += '-' + pv.otherCode
        }
        return code
    },
    exportContactsAndLeads(filter){
        var data = []
        var contact = ''
        var name = ''
        console.log(this.exportSalespersonFilter)
        console.log(filter)
        var customerContacts = [], leads = []
        var emailsAdded = {}


        if(filter === 'avecor_companies_no_salesperson') {
            for (const key of Object.keys(this.companies)) {
                if (this.companies[key] === undefined) {console.log(this.companies[key]); continue}
                var c = this.companies[key]
                if(c.salesperson) continue

                var created_at = c.created_at ? this.customFormatter(c.created_at) : ''
        
                contact = {
                    //myyjä: this.staff[c.salesperson] !== undefined ? this.staff[c.salesperson].firstName : '',
                    yrityksen_nimi: c.companyName,
                    yrityksen_y_tunnus: c.companyId,
                    yrityksen_osoite: c.deliveryAddress,
                    yrityksen_postikoodi:c.deliveryPostalCode,
                    yrityksen_kaupunki: c.deliveryCity,
                    yrityksen_maa: c.deliveryCountry,
                }
                customerContacts.push(contact)
            }   
        }
        if(filter === 'avecor_contacts' || filter === 'avecor_contacts_no_orders_in_two_years' || filter === 'avecor_contacts_and_non_prio_leads' || filter === 'avecor_contacts_and_all_leads' || filter === 'avecor_contacts_and_non_prio_leads_already_contacted'){
            /* var lastSoldDates = {}
            Object.keys(this.orders).forEach(oId => {
                var o = this.orders[oId]
                var y_tunnus = this.companies[o.companyId] && this.companies[o.companyId].companyId ? this.companies[o.companyId].companyId.trim() : ''
                var contactEmail = this.contacts[o.contactId] && this.contacts[o.contactId].email ? this.contacts[o.contactId].email.trim() : '' 
                if(y_tunnus && contactEmail){
                    var lastSoldIdentifier = y_tunnus + contactEmail
                    if(!lastSoldDates[lastSoldIdentifier] && o.created_at.seconds){
                      lastSoldDates[lastSoldIdentifier] = {}
                      lastSoldDates[lastSoldIdentifier].seconds = o.created_at.seconds
                      lastSoldDates[lastSoldIdentifier].date = this.customFormatter(o.created_at)
                    }
                    else {
                      //console.log("---START----")
                      //console.log({prev_date:lastSoldDates[o.companyId].seconds,this_date:o.created_at.seconds})
                      //console.log({prev_date:lastSoldDates[o.companyId].date,this_date:this.customFormatter(o.created_at)})//this.customFormatter(o.created_at)
                      if(new Date(lastSoldDates[lastSoldIdentifier].seconds*1000) < new Date(o.created_at.seconds*1000)){
                        //console.log({prev_date:lastSoldDates[o.companyId].date,this_date:this.customFormatter(o.created_at)})
                        lastSoldDates[lastSoldIdentifier].seconds = o.created_at.seconds
                        lastSoldDates[lastSoldIdentifier].date = this.customFormatter(o.created_at)
                      }
                      //console.log("---END----")
                    }
                }
            }) */
            
            var twoYearsAgo = new Date()
            twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
            
            for (const key of Object.keys(this.contacts)) {
                if (this.contacts[key] === undefined) {console.log(this.contacts[key]); continue}
                if(this.companies[this.contacts[key].companyId] === undefined){continue}
                var created_at = this.contacts[key].created_at ? this.customFormatter(this.contacts[key].created_at) : ''
                var c = this.contacts[key]
                var email = c.email ? c.email.replace(' ', '') : ''
                if(!this.companies[c.companyId]) continue
                var company = this.companies[c.companyId]
                var y_tunnus2 = this.companies[this.contacts[key].companyId] && this.companies[this.contacts[key].companyId].companyId ?  this.companies[this.contacts[key].companyId].companyId.trim() : ''
                var lastSoldIdentifier = y_tunnus2 + c.email.trim()
                if(emailsAdded[email] || !email) continue

                // FILTER OUT OVER TWO YEAR NO ORDERS
                if(filter === 'avecor_contacts_no_orders_in_two_years'){
                    if(company.latestOrderDate && (new Date(company.latestOrderDate) > twoYearsAgo)) continue
                }
                
        
                contact = {
                    kontaktin_tyyppi:'Asiakaskontakti',
                    myyjä: this.staff[this.companies[c.companyId].salesperson] !== undefined ? this.staff[this.companies[c.companyId].salesperson].firstName : '',
                    yrityksen_nimi: this.companies[c.companyId].companyName,
                    yrityksen_y_tunnus: this.companies[c.companyId].companyId,
                    yrityksen_osoite: this.companies[c.companyId].deliveryAddress,
                    yrityksen_kaupunki: this.companies[c.companyId].deliveryCity,
                    yrityksen_maa: this.companies[c.companyId].deliveryCountry,
                    kontaktin_nimi:c.firstName + ' ' +c.lastName,
                    kontaktin_puhelinnumero:c.phone ? c.phone.replace(' ', '') : '',
                    kontaktin_sähköpostiosoite:email,
                }
                email ? emailsAdded[email] = true : ''
                if(this.exportSalespersonFilter === 'all') customerContacts.push(contact)
                else if(this.exportSalespersonFilter  === this.companies[c.companyId].salesperson) customerContacts.push(contact)
            }
      
            customerContacts = customerContacts.sort(function(a,b){
                return new Date(a.viimeinen_kauppa_pvm) - new Date(b.viimeinen_kauppa_pvm);
            });
        }
        

        if(filter === 'non_prio_leads' || filter === 'avecor_contacts_and_non_prio_leads' || filter === 'avecor_contacts_and_all_leads'  || filter === 'avecor_contacts_and_non_prio_leads_already_contacted'){
            for (const key of Object.keys(this.leadsMap)) {
                if (this.leadsMap[key] === undefined) {console.log(this.leadsMap[key]); continue}
                var l = this.leadsMap[key]
                if((filter === 'non_prio_leads' || filter === 'avecor_contacts_and_non_prio_leads' || filter === 'avecor_contacts_and_non_prio_leads_already_contacted') && l.preparationStatus === 'priority_ready_for_contact') continue
                if(filter === 'avecor_contacts_and_non_prio_leads_already_contacted' && !l.email_1_sends) continue
                var pc = l.deliveryPostalCode ? l.deliveryPostalCode.trim() : ''
                var length = pc.length
                if (length == 4) pc = '0' + pc
                if (length == 3) pc = '00' + pc
                var salesperson = ''
                var salespersonName = ''
                //console.log(l)
                if(this.configMap['sales_regions'] && this.configMap['sales_regions'].postalCodes && this.configMap['sales_regions'].postalCodes[pc]) salesperson = this.configMap['sales_regions'].postalCodes[pc].salesperson
                if(salesperson && this.staff[salesperson]) salespersonName = this.staff[salesperson].firstName 

                var created_at = l.created_at ? this.customFormatter(l.created_at) : ''
                contact = {
                  kontaktin_tyyppi:'Liidi',
                  myyjä: salespersonName,
                  yrityksen_nimi: l.companyName,
                  yrityksen_y_tunnus: l.companyId,
                  yrityksen_osoite: l.deliveryAddress,
                  yrityksen_kaupunki: l.deliveryCity,
                  yrityksen_maa: l.deliveryCountry,
                  kontaktin_nimi:l.firstName + ' ' +l.lastName,
                  kontaktin_puhelinnumero:l.contactPhone,
                  kontaktin_sähköpostiosoite:l.contactEmail,
                }
                if(this.exportSalespersonFilter === 'all') leads.push(contact)
                else if(this.exportSalespersonFilter  === salesperson) leads.push(contact)
            }
        }


        if(this.exportSalespersonFilter === 'all')name = 'Kaikki'
        else name = this.staff[this.exportSalespersonFilter].firstName

        if(filter === 'avecor_contacts_and_non_prio_leads') name = name + ' Asiakkaiden ja Ei-prio Liidien Kontaktiedot'
        else if(filter === 'non_prio_leads') name = name + ' Ei-prio Liidien Kontaktiedot'
        else if(filter === 'avecor_contacts') name = name + ' Asiakkaiden Kontaktiedot'
        else if(filter === 'avecor_contacts_no_orders_in_two_years') name = name + ' Yli 2v Ei Kauppaa Asiakkaiden Kontaktiedot'
        else if(filter === 'avecor_contacts_and_all_leads') name = name + ' Asiakkaiden ja kaikkien liidien Kontaktiedot'
        else if(filter === 'avecor_contacts_and_non_prio_leads_already_contacted') name = name + ' Asiakkaiden ja Ei-prio Liidit Joille Lähetetty jo Sähköpostia Kontaktiedot'
        
        

        data = [...customerContacts, ...leads]

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:name, 
          //showTitle: true,
          //title:name +  'Kontaktitiedot',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        try{
            if(data.length == 0) throw Object.assign(new Error("Valitulle myyjälle ei löytynyt yrityksiä."))
            const csvExporter = new ExportToCsv(options);
            console.log(data)
            csvExporter.generateCsv(data);
        }
        catch(e){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:e.message, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
        
    },
    async logToOrderHistory(user,copyOfLogs,oId,opId,pName,whichStatus,oldStatus,newStatus){
        var db = firebase.firestore();
        try {
            var id1 = Math.random().toString(36).substr(2, 9);
            var id2 = Math.random().toString(36).substr(2, 9);
            var id = id1+id2
            var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date());
            var u = user

            var updateDetails = {
                id,
                type:'op_status_update',
                opId,
                pName,
                whichStatus,
                oldStatus,
                newStatus,
                date:firebaseDate,
                showInHistory:true,
                userUid:u.uid,
                userEmail:u.email
            }
            copyOfLogs.unshift(updateDetails)
            /* db.collection('orders').doc(oId).set({ 
                activityLog:copyOfLogs
            }, { merge: true }) */
            
            await this.$store.dispatch('order/set', {
                id:oId,
                activityLog:copyOfLogs
            })
        }
        catch(e){
            console.log(e) 
        }  
    },
    logStockUpdateProductChange(pId,pvId,oId,opId,userId,previousStock,newStock,changeAmount,changeType){
        try{
            var firebaseDate = firebase.firestore.Timestamp.fromDate(new Date());
            const ref = firebase.firestore().collection('productVariationChangeLogs').doc(pvId).set({
                id:pvId,  
                productId:pId,
                avecorStockUpdates:firebase.firestore.FieldValue.arrayUnion({
                    date:firebaseDate,
                    orderId:oId ? oId : '',
                    opId: opId ? opId : '',
                    userId: userId ? userId : '',
                    previousStock: previousStock ? previousStock :'',
                    newStock: newStock ? newStock : '',
                    changeAmount: changeAmount ? changeAmount :'',
                    changeType: changeType? changeType : ''
                })
            },{ merge: true })
        }
        catch(e){
            console.log(e)
        }
    },
    inlineSavePrintShopCategoryOptions(productId, newPrintCategories, field){
        var currentPrintCategories = this.products[productId].printShopCategories ? this.products[productId].printShopCategories : []
        console.log(this.products[productId].printShopCategories)
        console.log(newPrintCategories)
        var categoriesToRemove = []
        currentPrintCategories.forEach(c => {
            if(!newPrintCategories.includes(c)) categoriesToRemove.push(c)
        })
        console.log(categoriesToRemove)
        categoriesToRemove.forEach(c=> {
            var ids = c.split("__")
            if(this.printShops[ids[0]] && this.printShops[ids[0]].printFormatsPrices[ids[1]] && this.printShops[ids[0]].printFormatsPrices[ids[1]].categories[ids[2]] && this.printShops[ids[0]].printFormatsPrices[ids[1]].categories[ids[2]].productsUsing){
                var ps = this.printShops[ids[0]]
                var printFormatsPrices = JSON.parse(JSON.stringify(ps.printFormatsPrices))
                var productsUsing = printFormatsPrices[ids[1]].categories[ids[2]].productsUsing
                var newProductsUsing = productsUsing.filter(pId => {return pId !== productId})
                printFormatsPrices[ids[1]].categories[ids[2]].productsUsing = newProductsUsing
                this.$store.dispatch('printShop/set', {
                    id:ids[0],
                    printFormatsPrices,
                }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }   
            //filter(s => {return s.id !== 'no_selection'}
        })

        newPrintCategories.forEach(c => {
          var ids = c.split("__")
          if(this.printShops[ids[0]] && this.printShops[ids[0]].printFormatsPrices[ids[1]] && this.printShops[ids[0]].printFormatsPrices[ids[1]].categories[ids[2]]){
            var ps = this.printShops[ids[0]]
            var printFormatsPrices = JSON.parse(JSON.stringify(ps.printFormatsPrices))
            var updateNeeded = false
            if(!printFormatsPrices[ids[1]].categories[ids[2]].productsUsing) {
                updateNeeded = true
                printFormatsPrices[ids[1]].categories[ids[2]].productsUsing = [productId]
            }
            else if(!printFormatsPrices[ids[1]].categories[ids[2]].productsUsing.includes(productId)){
                printFormatsPrices[ids[1]].categories[ids[2]].productsUsing.push(productId)
                updateNeeded = true
            }
            if(updateNeeded){
                this.$store.dispatch('printShop/set', {
                    id:ids[0],
                    printFormatsPrices,
                }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
            }
          }
          console.log(ids)
        })
        this.$store.dispatch('product/set', {
          id:productId,
          [field]:newPrintCategories,
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        
    },
    
    getOptionDetailsById(p,poId,lang){
        var settings = this.settings
        var ids = poId.split('__')
        var optionFrom = ids[0]
        var level1IdentifierAsProductVariation = false
        if(p.prices && p.prices.level1IdentifierAsProductVariation) level1IdentifierAsProductVariation = true
        var poTexts = {pf:'',others:[]}
        if(optionFrom === 'product'){
            var oId = ids[1]
            var l1name = p.prices.level1Identifier ? p.prices.level1Identifier : ''
            var l2name = p.prices.level2Identifier ? p.prices.level2Identifier : ''
            p.prices.options.forEach((o,i) => {
                if(o.id === oId){
                    var pfId = o.printFormat
                    if(settings.printFormatsObject[pfId]) {
                        var pf = settings.printFormatsObject[pfId]
                        poTexts.pf = pf[lang]
                    }
                    var l1 = o.level1.trim()
                    var l2 = o.level1.trim()
                    if(!level1IdentifierAsProductVariation && l1name && l1){
                        poTexts.others.push(l1name +': ' + l1)
                    }
                    if(l2name && l2){
                        poTexts.others.push(l2name +': ' + l2)
                    }
                }
            })
        }
        else if (optionFrom === 'printShop'){
            var psId = ids[1]
            var pfId = ids[2]
            var cId = ids[3]
            var oId = ids[4]
            var ps = this.printShops[psId] 
            if(ps && ps.printFormatsPrices[pfId] && ps.printFormatsPrices[pfId].categories[cId]){
                var c = ps.printFormatsPrices[pfId].categories[cId]
                var l1name = c.level1Identifier ? c.level1Identifier : ''
                var l2name = c.level2Identifier ? c.level2Identifier : ''
                var options = c.options
                options.forEach((o,i) => {
                    if(o.id === oId){
                        if(settings.printFormatsObject[pfId]) {
                            var pf = settings.printFormatsObject[pfId]
                            poTexts.pf = pf[lang]
                        }
                        var l1 = o.level1.trim()
                        var l2 = o.level1.trim()
                        if(l1name && l1){
                            poTexts.others.push(l1name +': ' + l1)
                        }
                        if(l2name && l2){
                            poTexts.others.push(l2name +': ' + l2)
                        }
                    }
                })
            }
        }
        return poTexts
    },

    printFormatsFromPricingForProduct(productId,filterArchived){
        try{
            var formats = []
            var products = this.products
            var pvs = this.productVariations
            var settings = this.settings
            var printShops = this.printShops
            /* PRICE OPTIONS FROM PRODUCT LEVEL */
            var product = products[productId]
            var level1IdentifierAsProductVariation = product.prices.level1IdentifierAsProductVariation ? true : false
            if(products[productId] && products[productId].prices ){
                var p =  products[productId].prices
                var extraCosts = p.extraCosts && p.extraCosts.length > 0 ? JSON.parse(JSON.stringify(p.extraCosts)) : []
                
                var l1name = p.level1Identifier ? p.level1Identifier : ''
                var l2name = p.level2Identifier ? p.level2Identifier : ''
                
                if(p.options && p.options.length > 0){
                    p.options.forEach(o => {
                        var text = ''
                        var cArchived = false
                        if(o.printShopOptionFullId){
                            var aId = o.printShopOptionFullId
                            var ids = aId.split('__')
                            var psId = ids[0]
                            var pfId = ids[1]
                            var cId = ids[2]
                            var ps = this.printShops[psId]
                            //var pfName = settings.printFormatsObject[pfId] ? settings.printFormatsObject[pfId].fi : ''
                            var c = ps.printFormatsPrices[pfId].categories[cId]
                            cArchived = c.archived ? true : false
                            if(filterArchived && cArchived) return
                            
                        }
                        
                        
                        var l1 = o.level1.trim()
                        if(level1IdentifierAsProductVariation){
                            if(l1 && pvs[l1]){
                                l1 = this.createVariationName(pvs[l1],true)
                            }
                        }
                        var l2 = o.level2.trim()
                        var pfId = o.printFormat ? o.printFormat : ''
                        var psId = o.psId ? o.psId : ''
                        if(pfId === 'no_print') return
                        if(pfId === '') return
                        var pfName = ''
                        this.settings.printFormatsObject[pfId] ? pfName = this.settings.printFormatsObject[pfId].fi : ''
                        
                        if(l1 !== '' && l2 !== '') text += ' | ' + l1name + ' ' + l1 + ' | ' + l2name + ' ' + l2
                        if(l1 !== '' && l2 === '') text += ' | ' + l1name + ' ' + l1
                        if(l1 === '' && l2 !== '') text += ' | ' + l2name + ' ' + l2
                        var id = 'product__'+o.id
                        if(text !== '') text = pfName + text
                        else text = pfName 

                        if(cArchived) text = 'ARKISTOITU || ' + text
                        console.log(o)

                        if(o.unitPrices && o.unitPrices.renewCosts && o.unitPrices.renewCosts.price){
                            console.log({pfId,text,renewAvailable:true,id})
                            formats.push({id:id,text,pfId,psId,renewAvailable:true,extraCosts})  
                        }
                        else {
                            console.log({pfId,text,renewAvailable:false,id})
                            formats.push({id:id,text,pfId,psId,renewAvailable:false,extraCosts})
                        }

                    })
                }
            }
            
            /* PRINT SHOP CATEGORY OPTIONS */
            if(products[productId].printShopCategories && products[productId].printShopCategories.length > 0){
                products[productId].printShopCategories.forEach(aid => {
                    var ids = aid.split('__')
                    var psId = ids[0]
                    var pfId = ids[1]
                    var cId = ids[2]
                    var oId = ids[3]
                    if(!printShops[psId]) return
                    var ps = printShops[psId]
                    if(!ps.printFormatsPrices[pfId]) return
                    if(!ps.printFormatsPrices[pfId].categories[cId]) return
                    
                    var c = ps.printFormatsPrices[pfId].categories[cId]
                    var cArchived = c.archived ? true : false
                    if(filterArchived && cArchived) return

                    var pfName = settings.printFormatsObject[pfId] ? settings.printFormatsObject[pfId].fi : ''
                    
                    var extraCosts = c.extraCosts && c.extraCosts.length > 0 ? JSON.parse(JSON.stringify(c.extraCosts)) : []
                    var l1name = c.level1Identifier
                    var l2name = c.level2Identifier

                    c.options.forEach(o => {
                        if(o.id === oId){
                            var text = ''
                            var l1 = o.level1.trim()
                            if(level1IdentifierAsProductVariation){
                                if(l1 && pvs[l1]){
                                    l1 = this.createVariationName(pvs[l1],true)
                                }
                            }
                            var l2 = o.level2.trim()

                            if(l1 !== '' && l2 !== '') text += l1name + ' ' + l1 + ' | ' + l2name + ' ' + l2
                            if(l1 !== '' && l2 === '') text += l1name + ' ' + l1
                            if(l1 === '' && l2 !== '') text += l2name + ' ' + l2
                            if(text !== '') text = pfName + ' | ' + c.name + ' | ' + text
                            else text = pfName + ' | ' + c.name

                            if(cArchived) text = 'ARKISTOITU || ' + text
                            var id = 'printShop__' + aid
                            
                            if(o.unitPrices && o.unitPrices.renewCosts && o.unitPrices.renewCosts.price){
                                formats.push({id:id,text,pfId,psId,renewAvailable:true,extraCosts})  
                            }
                            else formats.push({id,text,pfId,psId,renewAvailable:false,extraCosts})
                        }
                    })
                })
            }
            /* PRINT SHOP PRTIN CATEGORIES */
            if(products[productId] && products[productId].printShopWholeCategories && products[productId].printShopWholeCategories.length > 0){
                products[productId].printShopWholeCategories.forEach(ppc => {
                    var ids = ppc.split('__')
                    try{
                        var psId = ids[0]
                        var pfId = ids[1]
                        var cId = ids[2]

                        if(!printShops[psId]) return
                        var ps = printShops[psId]
                        if(!ps.printFormatsPrices[pfId]) return
                        if(!ps.printFormatsPrices[pfId].categories[cId]) return

                        var c = ps.printFormatsPrices[pfId].categories[cId]
                        console.log(c)
                        var cArchived = c.archived ? true : false
                        if(filterArchived && c.archived) return
                        
                        var extraCosts = c.extraCosts && c.extraCosts.length > 0 ? JSON.parse(JSON.stringify(c.extraCosts)) : []
                        var l1name = c.level1Identifier
                        var l2name = c.level2Identifier

                        c.options.forEach(o => {
                            var text = ''
                            var l1 = o.level1.trim()
                            var l2 = o.level2.trim()
                            if(l1 !== '' && l2 !== '') text += l1name + ' ' + l1 + ' | ' + l2name + ' ' + l2
                            if(l1 !== '' && l2 === '') text += l1name + ' ' + l1
                            if(l1 === '' && l2 !== '') text += l2name + ' ' + l2
                            //if(text === '') return

                            var pfName = settings.printFormatsObject[pfId] ? settings.printFormatsObject[pfId].fi : ''
                            if(text !== '') text = pfName + ' | ' + c.name + ' | ' + text
                            else text = pfName + ' | ' + c.name
                            
                            if(cArchived) text = 'ARKISTOITU || ' + text

                            var oId = o.id
                            if(!oId) return
                            var id = 'printShop__' + ppc + '__' + oId
                            
                            if(o.unitPrices && o.unitPrices.renewCosts && o.unitPrices.renewCosts.price){
                                formats.push({id:id,text,pfId,psId,renewAvailable:true,extraCosts})  
                            }
                            else formats.push({id,text,pfId,psId,renewAvailable:false,extraCosts})
                        })
                    }
                    catch(e){
                        console.log("ERROR with print shop category")
                        console.log(ppc)
                        console.log(e)
                        
                    }
                })
            }
            return formats
        }
        catch(e){
            console.log(e)
            return []
        }

        
    },
    calculateReserved(){
        var t = this
        var reserved = {
          avecor:{}
        }
        var orderedProducts = this.orderedProducts
        var orders = this.orders
        Object.keys(orderedProducts).forEach(opId => {
          var op = orderedProducts[opId]
          var p = t.products[op.productId]
          
          var o = orders[op.orderId]
          if(!p) return
          
          var pId = op.productId
          var pvId = op.productVariationId
          var os = op.orderStatus
          reserved.avecor[pId] ? '' : reserved.avecor[pId] = {reserved:0, variations:{}}
          reserved.avecor[pId].variations[pvId] ? '' : reserved.avecor[pId].variations[pvId] = {total:0,details:[]}
          reserved.avecor[pId].variations[pvId] ? '' : reserved.avecor[pId].variations[pvId] = 0
          
          // salesRequestedToContactForLogo salesRequestedToContactForDraft salesRequestedToContact
          //console.log(Number.isInteger(parseInt(op.quantity)))
          if(op.quantity && Number.isInteger(parseInt(op.quantity)) && os && os !== 'productsShipped' && os !== 'salesRequestedToContactForLogo' && 
                os !== 'salesRequestedToContactForDraft'  && os !== 'salesRequestedToContact' && os !== 'cancelled' && !op.archived){
                //console.log(op.quantity)
                var m = p.orderUnitToStockUnitMultiplier && !isNaN(Number(p.orderUnitToStockUnitMultiplier)) ? p.orderUnitToStockUnitMultiplier : 1
                var quantityToAdd = (parseInt(op.quantity)*m)
                var numberOfSamples = op.numberOfSamples && !isNaN(Number(op.numberOfSamples)) ? Number(op.numberOfSamples) : 0
                numberOfSamples = numberOfSamples*m
                /* quantityToAdd = parseFloat(quantityToAdd)
                quantityToAdd = quantityToAdd * 100
                quantityToAdd = Math.round(quantityToAdd)
                quantityToAdd = quantityToAdd / 100 */
                if(pvId === "GI1VeyPbn172DsFY7Ucu") console.log(op)

                reserved.avecor[pId].reserved = reserved.avecor[pId].reserved + quantityToAdd + numberOfSamples
                reserved.avecor[pId].reserved = reserved.avecor[pId].reserved * 100
                reserved.avecor[pId].reserved = Math.round(reserved.avecor[pId].reserved)
                reserved.avecor[pId].reserved = reserved.avecor[pId].reserved / 100
                reserved.avecor[pId].variations[pvId].total = reserved.avecor[pId].variations[pvId].total + quantityToAdd + numberOfSamples
                reserved.avecor[pId].variations[pvId].total = reserved.avecor[pId].variations[pvId].total * 100
                reserved.avecor[pId].variations[pvId].total = Math.round(reserved.avecor[pId].variations[pvId].total)
                reserved.avecor[pId].variations[pvId].total = reserved.avecor[pId].variations[pvId].total / 100

                /* if(pId === 'sNs6RnJtlXzvKSq42Yj8') {
                    console.log('ADDING QUANTITY',quantityToAdd)
                    console.log('TOTAL RESERVED PRODUCT',reserved.avecor[pId].reserved)
                    console.log('TOTAL RESERVED PV',reserved.avecor[pId].variations[pvId].total)
                } */
                var orderedDate = ""
                
                try{ orderedDate = this.customFormatter(op.created_at); } catch(e) {console.log("DATE COULD NOT BE PROCESSED")}
                var companyName = t.companies[t.orders[op.orderId].companyId] ? t.companies[t.orders[op.orderId].companyId].companyName : ''
                var orderQuantity = parseInt(op.quantity)
                var quantity = parseInt(op.quantity)*m
                quantity += numberOfSamples
                var orderStatusText = t.settings.orderedProductStatusObject[op.orderStatus].text
                var orderStatusColor = t.settings.orderStatusColors[op.orderStatus]
                var archived = op.archived
                var orderInvoiceStatusText = t.settings.orderedProductInvoiceStatusObject[op.orderInvoiceStatus].text
                var orderInvoiceStatusColor = t.settings.orderStatusColors[op.orderInvoiceStatus]
                var netvisorId = t.orders[op.orderId].netvisorId ? t.orders[op.orderId].netvisorId : ''


                reserved.avecor[pId].variations[pvId].details.push({
                    opId,
                    orderId:op.orderId,
                    created_at:o.created_at,
                    orderedDate,
                    companyName,
                    orderQuantity,
                    quantity,
                    numberOfSamples,
                    orderStatus:op.orderStatus,
                    orderStatusText,
                    orderInvoiceStatus:op.orderInvoiceStatus,
                    orderInvoiceStatusText,
                    orderStatusColor,
                    orderInvoiceStatusColor,
                    netvisorId
                })
              //console.log(reserved.avecor[pId].variations[pvId])
          }
        })

        Object.keys(reserved.avecor).forEach(pId => {
            Object.keys(reserved.avecor[pId].variations).forEach(pvId => {
                if(reserved.avecor[pId].variations[pvId].details){
                    // GET CURRENT STOCK
                    var availableStock = t.productVariations[pvId] && t.productVariations[pvId].avecorStock ? t.productVariations[pvId].avecorStock : 0
                    var notifyLevel = t.productVariations[pvId] && t.productVariations[pvId].avecorStockNotifyLevel ? t.productVariations[pvId].avecorStockNotifyLevel : null
                    var sorted = reserved.avecor[pId].variations[pvId].details.sort(function(a,b){
                        var a = new Date(a.created_at.seconds*1000)
                        var b = new Date(b.created_at.seconds*1000)
                        return  b -a
                    });
                    var incompleteShelf = []
                    var otherStatuses = []
                    sorted.forEach(i => {
                        if(i.orderStatus === "incompleteShelf") incompleteShelf.push(i)
                        else otherStatuses.push(i)
                    })
                    /* if(pvId === "4iQQjYtPtJxz1le0d1J6"){
                        console.log(incompleteShelf)
                        console.log(otherStatuses)
                    } */
                    sorted = [...otherStatuses,...incompleteShelf]
                    

                    for(var i = sorted.length-1; i >= 0; i--){
                        if(pvId === '1c3xuj80Rny4JlFz4MpU') console.log({availableStock})
                        availableStock = availableStock - sorted[i].quantity
                        if(availableStock >= 0) {
                            sorted[i].stockStatus = 'available'
                            sorted[i].stockAvailable = availableStock
                        }
                        else if(availableStock <= notifyLevel && availableStock > 0) {
                            sorted[i].stockStatus = 'availableButLowerThanStockNotifyLevel'
                            sorted[i].stockAvailable = availableStock
                        }
                        else {
                            sorted[i].stockStatus = 'notAvailable'
                            sorted[i].stockAvailable = availableStock
                        }
                    }

                    reserved.avecor[pId].variations[pvId].details = sorted
                }
            })
        })

        this.reserved = reserved
    },
    async syncOrderToNetvisor(orderId,env,invoiceType,invoiceObject){
        var self = this
        return new Promise(async function(resolve, reject) {
            try{
                invoiceType ? '' : invoiceType = 'order'
                var productsData = []
                var o = self.orders[orderId]
                                
                if(self.isSyncOrderToNetvisorActive ) {
                    throw Object.assign(new Error("Edellinen synkronointi vielä käynnissä."))
                }
                if(!o.companyId || !self.companies[o.companyId] || !self.companies[o.companyId].companyId ) {
                    throw Object.assign(new Error("Netvisor synkrynointi epäonnistui: Yrityksen y-tunnus puuttuu."))
                }
            
                if(env === 'production'){
                    if(!o.netvisorKey && o.netvisorId) throw Object.assign(new Error("Tätä tilausta ei voida synkronoida."))
                }
                else {
                    if(!o.netvisorKey_test_env && o.netvisorId_test_env) throw Object.assign(new Error("Tätä tilausta ei voida synkronoida."))
                }
                
                Object.keys(self.orderedProducts).forEach(opId => {
                    var op = self.orderedProducts[opId]
                    console.log("HERE2")
                    if(op.orderId === orderId){
                        var p = self.products[op.productId]
                        var vatPercentage = p && p.vatPercentage ? p.vatPercentage : "25_5"
                        var pv = self.productVariations[op.productVariationId]
                        var productVariationName = ""
                        try{
                            productVariationName = p.name.fi  + ' - ' +self.createVariationNameDataIncluded(pv,self.settings,true)
                        }
                        catch(e){
                            throw Object.assign(new Error("Tuotteelle ei voitu muodostaa nimeä"))
                        }
                        
                        productsData.push({
                            avecorSku: self.createVariationAvecorSkuDataIncluded(p,pv,self.settings),
                            productVariationName,
                            vatPercentage,
                            ...op
                        })
                    }
                })

                var snackText = "Tilausta synkronoidaan Netvisoriin..."
                if(invoiceType === 'invoice' && invoiceObject.selectedInvoice) snackText = "Laskua päivitetään Netvisoriin..."
                else if(invoiceType === 'invoice' && invoiceObject.selectedInvoice === '') snackText = "Laskua luodaan Netvisoriin..."
                self.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText, snackButtonText: "OK", errorType:"", snackColor:'deep-blue',right:true,top:true})
                
                var salesperson = o.salesperson
                var companyData = self.companies[o.companyId]
                var contactData = self.contacts[o.contactId]
                var salespersonFirstName = self.staff[salesperson] && self.staff[salesperson].firstName ? self.staff[salesperson].firstName : ''
                var salespersonLastName = self.staff[salesperson] && self.staff[salesperson].firstName ? self.staff[salesperson].lastName : ''
                
                var salespersonNetvisorKey = self.staff[salesperson] && self.staff[salesperson].netvisorKey ? self.staff[salesperson].netvisorKey : ''
                await self.$store.dispatch('syncToNetvisor', {
                    rt:"order",
                    companyData:{...companyData,salespersonFirstName,salespersonLastName,salespersonNetvisorKey},
                    productsData:productsData,
                    env:env,
                    invoiceType:invoiceType,
                    invoiceObject:invoiceObject,
                    contactData,
                    orderData:o
                })
                self.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tilaustiedot synkronoitu.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
                //await self.$store.dispatch('syncOrderToNetvisor', {orderId,productsData,env,invoiceType,invoiceObject})
                resolve("ok")
            }
            catch(e){
                console.log(e)
                self.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:e, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
                reject(e)
            }
        })
    },
    
    async syncCompanyToNetvisor(companyId,env){
        try{
          await this.$store.dispatch('syncCompanyToNetvisor', {companyId,env})
        }
        catch(e){
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:e, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
    },
    addStickyHeaders:function(idPrefix,paddingForContent){
        // When the user scrolls the page, execute myFunction 
      window.onscroll = function() {myFunction()};

      // Get the header
      var header = document.getElementById(idPrefix+'-headers');
      var content = document.getElementById(idPrefix+'-content');

      // Get the offset position of the navbar
      var sticky = header.offsetTop;

      // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
      function myFunction() {
        if (window.pageYOffset +10 > sticky) {
          header.classList.add(idPrefix+"-headers-sticky");
          content.style.paddingTop = paddingForContent+'px'

        } else {
          header.classList.remove(idPrefix+"-headers-sticky");
          content.style.paddingTop = '0px'
        }
      }
    },
    
    formNewBatchDataset: function(data) { 
        var reduceFromStockLocation = "avecor"
        
        var clonedBatches = {}
        var opId = data.opId
        var isAlwaysAvecorStock = data.productVariation.isAlwaysAvecorStock !== undefined ? data.productVariation.isAlwaysAvecorStock : false
        if(isAlwaysAvecorStock){
            reduceFromStockLocation = "avecor"
        }
        else {
            if(data.isPrint) reduceFromStockLocation = "printShop"
        }
        if(data.productVariation.batches !== undefined){
            clonedBatches = JSON.parse(JSON.stringify(data.productVariation.batches ))
        }
        var arrivingBatches = []
        var arrivedBatches = []

        Object.keys(clonedBatches).forEach(batchId => {
            clonedBatches[batchId].status !== undefined 
            && (clonedBatches[batchId].status === "batchArrivedToWarehouse" || clonedBatches[batchId].status ==="batchShelfed")
            && clonedBatches[batchId].stockLocation === reduceFromStockLocation ? arrivedBatches.push(batchId) : ''
        })
        arrivedBatches.sort(function(a,b){
            return new Date(clonedBatches[a].arrivalDate) - new Date(clonedBatches[b].arrivalDate)
        });
        var isNextBatchNeeded = true
        var quantityLeft = Number(data.quantity)
        var batchIds = []
          
          
        // FIRST IN STOCK BATCHES
        arrivedBatches.forEach(batchId =>{
            var batch = clonedBatches[batchId]
            var reservationsTotal = 0
            if(isNextBatchNeeded){
                batch.reservations === undefined ? batch.reservations = {} : ""
                batch.reservations.orderedProducts === undefined ? batch.reservations.orderedProducts = {} : ""
                batch.reservations.total === undefined ? batch.reservations.total = 0 : ""
                var reservationsTotal = batch.reservations.total
                if (reservationsTotal < batch.quantity){
                    // IF ADDED AMOUNT IS GREATER BATCH QUANITY LEFT OVER NEEDS TO BE ASSIGNED TO NEXT AVAILABLE BATCH
                    if(reservationsTotal >= batch.quantity){
                        // BATCH FULL
                        console.log("ARRIVED BATCH FULL")
                    }
                    else if((reservationsTotal + quantityLeft) > batch.quantity){
                        console.log("ARRIVED BATCH CANNOT FIT FULL AMOUNT")
                        batch.reservations.total = batch.quantity
                        var leftInBatch = batch.quantity - reservationsTotal
                        batch.reservations.orderedProducts[opId] = leftInBatch
                        quantityLeft = quantityLeft - leftInBatch
                        isNextBatchNeeded = true
                        batchIds.push(batchId)
                    }
                    // ELSE REMOVE THE FULL AMOUNT FROM THE BATCH
                    else {
                        console.log("ARRIVED BATCH CAN FIT LEFTOVER AMOUNT")
                        batch.reservations.total += quantityLeft
                        batch.reservations.orderedProducts[opId] = quantityLeft
                        isNextBatchNeeded = false
                        quantityLeft = 0
                        batchIds.push(batchId)
                    }
                }
            }
        })
        // SECOND ARRIVING BATCHES
        if(quantityLeft > 0){
            Object.keys(clonedBatches).forEach(batchId => {
                clonedBatches[batchId].status !== undefined 
                && clonedBatches[batchId].status === "batchOrdered" 
                && clonedBatches[batchId].stockLocation === reduceFromStockLocation ? arrivingBatches.push(batchId) : ''
            })
            arrivingBatches.sort(function(a,b){
                return new Date(clonedBatches[a].estimatedArrivalDate) - new Date(clonedBatches[b].estimatedArrivalDate)
            })

            arrivingBatches.forEach(batchId =>{
                var batch = clonedBatches[batchId]
                if(isNextBatchNeeded){
                    batch.reservations === undefined ? batch.reservations = {} : ""
                    batch.reservations.orderedProducts === undefined ? batch.reservations.orderedProducts = {} : ""
                    batch.reservations.total === undefined ? batch.reservations.total = 0 : ""
                    var reservationsTotal = batch.reservations.total
                    if (reservationsTotal < batch.quantity){
                        // IF ADDED AMOUNT IS GREATER BATCH QUANITY LEFT OVER NEEDS TO BE ASSIGNED TO NEXT AVAILABLE BATCH
                        if(reservationsTotal >= batch.quantity){
                            // BATCH FULL
                            console.log("ARRIVED BATCH FULL")
                        }
                        else if((reservationsTotal + quantityLeft) > batch.quantity){
                            console.log("ARRIVED BATCH CANNOT FIT FULL AMOUNT")
                            batch.reservations.total = batch.quantity
                            var leftInBatch = batch.quantity - reservationsTotal
                            
                            batch.reservations.orderedProducts[opId] = leftInBatch
                            quantityLeft = quantityLeft - leftInBatch
                            isNextBatchNeeded = true
                            batchIds.push(batchId)
                        }
                        // ELSE REMOVE THE FULL AMOUNT FROM THE BATCH
                        else {
                            console.log("ARRIVED BATCH CAN FIT LEFTOVER AMOUNT")
                            batch.reservations.total += Number(quantityLeft)
                            batch.reservations.orderedProducts[opId] = quantityLeft
                            isNextBatchNeeded = false
                            quantityLeft = 0
                            batchIds.push(batchId)
                        }
                    }
                }
            })
        }
          // THIRD PUT LEFT INTO UNALLOCATED
        if(quantityLeft > 0){
            console.log("COULD NOT BE ALLOCATED TO BACTHES FULLY:" +quantityLeft + " TO BE PUT TO UNALLOCATED")
            var unallocatedId = data.isPrint ? "unallocatedPrintShop" : "unallocatedAvecor"

            clonedBatches[unallocatedId] === undefined ? clonedBatches[unallocatedId] = {} : ''
            clonedBatches[unallocatedId].total === undefined ? clonedBatches[unallocatedId].total = 0 : ""
            clonedBatches[unallocatedId].total += quantityLeft
            clonedBatches[unallocatedId].orderedProducts === undefined ? clonedBatches[unallocatedId].orderedProducts = {} : ''
            clonedBatches[unallocatedId].orderedProducts[opId] = quantityLeft
            isNextBatchNeeded = false
            batchIds.push(unallocatedId)

        }

        return {clonedBatches,batchIds}
    },
    generateMarginsTableData(dataRestriction,metric, chartType, figureType, split,timeSplit,selectedYear,deliveryMarginsByOrder,headers) {
        var orderedProducts = this.orderedProducts
        var orders = this.orders
        var staff = this.staff
        var companies = this.companies
        var figures = {}
        var months = this.months
        var weeks = []
        var figuresByMonth ={}
        figuresByMonth[selectedYear] = {}
        months.forEach(month => figuresByMonth[selectedYear][month] = {})
        
        //var deliveryMarginsByOrder = this.generateDeliveryMarginsByOrder()

        
        if (metric === "orders" || metric === "newCustomers" || metric === "margins" || metric === "bothMargins"  || metric === "marginRate"){
            
                        
            /* CALCULATE RATES PER ORDER */
            let marginRateByOrder = {}
            Object.keys(orderedProducts).forEach(function(opId, index) {
                const op = orderedProducts[opId]
                const o = orders[op.orderId]
                const deliveryCharge = !o.deliveryCharge || isNaN(Number(o.deliveryCharge)) ? 0 : Number(o.deliveryCharge)
                var confirmedMargin = 0
                // JANNE KATEKERROIN MYYJÄN KATTEELLA
                /* if(o.salesperson === 'MG7ysPafpYMEQtqd0HJVzck3yXM2') confirmedMargin = op.salespersonMargin ? Number(op.salespersonMargin) : 0
                else confirmedMargin = op.confirmedMargin ? Number(op.confirmedMargin) : 0 */

                if(o.salesperson === 'MG7ysPafpYMEQtqd0HJVzck3yXM2') confirmedMargin = op.salespersonMargin ? Number(op.salespersonMargin) : 0
                else if (op.confirmedMargin) confirmedMargin = Number(op.confirmedMargin)
                else if (op.salespersonMargin) confirmedMargin = Number(op.salespersonMargin)

                var deliveryMarginByProduct = deliveryMarginsByOrder[op.orderId] ? deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct : 0
                var total = 0
                if(op.orderStatus !== 'cancelled'){
                    total = Number(op.printQuantity)*Number(op.unitPrintPrice) 
                        + Number(op.quantity)*Number(op.unitPrice) 
                        + Number(op.numberOfPositionings)*Number(op.pricePerPositioning) 
                }
                //total = total.toFixed(2)
                if(isNaN(total) ) total = 0

                marginRateByOrder[op.orderId] ? '' : marginRateByOrder[op.orderId] = {officeMargin:0,sales:0,marginRate:0,netvisorId:o.netvisorId}
                // DELIVERY CHARGE INCLUDED
                //marginRateByOrder[op.orderId] ? '' : marginRateByOrder[op.orderId] = {officeMargin:0,sales:deliveryCharge,marginRate:0,netvisorId:o.netvisorId}
                marginRateByOrder[op.orderId].officeMargin += (confirmedMargin + deliveryMarginByProduct)
                marginRateByOrder[op.orderId].sales += total
                marginRateByOrder[op.orderId].marginRate = (marginRateByOrder[op.orderId].sales/(marginRateByOrder[op.orderId].sales-marginRateByOrder[op.orderId].officeMargin))
                marginRateByOrder[op.orderId].marginRate = marginRateByOrder[op.orderId].marginRate.toFixed(2)
                marginRateByOrder[op.orderId].marginRate = Number(marginRateByOrder[op.orderId].marginRate)
            })

            console.log(marginRateByOrder)

            
            Object.keys(this.orders).map(function(key, index) {
                var o = orders[key]
                if(typeof companies[o.companyId] === "undefined") return {...o}
                var total = 0
                var total2 = 0
                var month,year = null
                var invoicesAllPaidMonth,invoicesAllPaidYear = null
                var salesperson = o.salesperson
                if(o.originalSalesperson) salesperson = o.originalSalesperson
                
                month = o.created_at.toDate().getMonth() +1
                year = o.created_at.toDate().getFullYear()
                
                var invoicesAllPaid = false
                if(o.invoicesAllPaid && o.invoicesPaidDate && o.invoicesPaidDate.seconds) invoicesAllPaid = true
                
                if(invoicesAllPaid){
                invoicesAllPaidMonth = o.invoicesPaidDate.toDate().getMonth() +1
                invoicesAllPaidYear = o.invoicesPaidDate.toDate().getFullYear()
                }
                
                total = o.salespersonMargin ? Number(o.salespersonMargin) : 0
                total2 = o.officeMargin !== undefined && o.officeMargin ? Number(o.officeMargin) : 0
                //if(metric === "bothMargins" && month === 6 && year === 2020) console.log(o)
                if(figuresByMonth[year] === undefined) figuresByMonth[year] = {}
                if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear] === undefined) figuresByMonth[invoicesAllPaidYear] = {}
                if(figuresByMonth[year][month] === undefined) figuresByMonth[year][month] = {}
                if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth] = {}
                if(figuresByMonth[year][month]["all"] === undefined) figuresByMonth[year][month]["all"] = {}
                if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"] = {}
                if(figuresByMonth[year][month][salesperson] === undefined) figuresByMonth[year][month][salesperson] = {}
                if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson] = {}

                // ORDER DATE MARGINS ALL
                if (year < 2024 || (year == 2024 && month <= 9)) {
                    if(figuresByMonth[year][month]["all"]["margins"] === undefined) figuresByMonth[year][month]["all"]["margins"] = total
                    else figuresByMonth[year][month]["all"]["margins"] += total
                    
                    // ORDER DATE MARGINS BY SALESPERSON
                    if(figuresByMonth[year][month][salesperson]["margins"] === undefined) figuresByMonth[year][month][salesperson]["margins"] = total
                    else figuresByMonth[year][month][salesperson]["margins"] += total
                    // ORDER DATE OFFICE MARGINS ALL
                    if(figuresByMonth[year][month]["all"]["officeMargins"] === undefined) figuresByMonth[year][month]["all"]["officeMargins"] = total2
                    else figuresByMonth[year][month]["all"]["officeMargins"] += total2
                    // ORDER DATE OFFICE MARGINS BY SALESPERSON
                    if(figuresByMonth[year][month][salesperson]["officeMargins"] === undefined) figuresByMonth[year][month][salesperson]["officeMargins"] = total2
                    else figuresByMonth[year][month][salesperson]["officeMargins"] += total2

                    // INVOICED DATE MARGINS ALL
                    if(invoicesAllPaid){
                        // INVOICES ALL PAID DATE MARGINS ALL
                        if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidMargins"] === undefined) figuresByMonth[year][month]["all"]["invoicesAllPaidMargins"] = total
                        else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidMargins"] += total
                        // INVOICES ALL PAID DATE MARGINS BY SALESPERSON
                        if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidMargins"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidMargins"] = total
                        else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidMargins"] += total
                        // INVOICES ALL PAID DATE OFFICE MARGINS ALL
                        if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidOfficeMargins"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidOfficeMargins"] = total2
                        else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidOfficeMargins"] += total2
                        // INVOICES ALL PAID DATE OFFICE MARGINS BY SALESPERSON
                        if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["officeinvoicesAllPaidOfficeMarginsMargins"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["officeinvoicesAllPaidOfficeMarginsMargins"] = total2
                        else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidOfficeMargins"] += total2
                    }
                }
                
                return {...o}
                
            })

          

            Object.keys(this.orderedProducts).forEach(function(opId, index) {
                var op = orderedProducts[opId]
                var o = orders[op.orderId]
                if (!o) return
                var confirmedMargin = op.confirmedMargin ? Number(op.confirmedMargin) : 0
                var salespersonMargin = op.salespersonMargin ? Number(op.salespersonMargin) : 0
                if(isNaN(Number(op.salespersonMargin)) &&  op.salespersonMargin) {
                    console.log("INVALID SALESPERSON MARGIN INSERTED")
                    console.log(op)
                }
                if(isNaN(Number(op.confirmedMargin)) &&  op.confirmedMargin) {
                    console.log("INVALID OFFICE MARGIN INSERTED")
                    console.log(op)
                }

                var salesperson = op.salesperson
                if(op.originalSalesperson) salesperson = op.originalSalesperson
                // SUBTRACT DELIVERY MARGIN BY PRODUCT 
                if(deliveryMarginsByOrder[op.orderId]){
                confirmedMargin = confirmedMargin + deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct
                salespersonMargin = salespersonMargin + deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct
                //if(salesperson === 'GJ51vbQ1pLNNJMeKc4896QKdjVr1' && invoicedMonth == 9) console.log(deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct)
                }

                var created_at = null
                if (op.created_at !== undefined && op.created_at.seconds !== undefined){
                created_at = op.created_at
                }
                else if (op.created_at !== undefined && op.created_at.seconds === undefined) {
                var seconds = new Date(op.created_at).getTime()/1000
                created_at = {seconds}
                }
                var opCreatedMonth = created_at.toDate().getMonth() +1
                var opCreatedYear = created_at.toDate().getFullYear()

                var orderMarginRate = marginRateByOrder[o.id] ? marginRateByOrder[o.id].marginRate : 0

                // ORDER DATE MARGINS
                if (opCreatedYear > 2024 || (opCreatedYear == 2024 && opCreatedMonth > 9)) {
                    if(figuresByMonth[opCreatedYear] === undefined) figuresByMonth[opCreatedYear] = {}
                    if(figuresByMonth[opCreatedYear][opCreatedMonth] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth] = {}
                    if(figuresByMonth[opCreatedYear][opCreatedMonth]["all"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth]["all"] = {}
                    if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson] = {}

                    if(figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["margins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["margins"] = salespersonMargin
                    else figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["margins"] += salespersonMargin
                    
                    
                    
                    // ORDER DATE MARGINS BY SALESPERSON
                    if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins"] = salespersonMargin
                    else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins"] += salespersonMargin

                    if(orderMarginRate <= 1.99){
                        if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level1"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level1"] = salespersonMargin
                        else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level1"] += salespersonMargin
                    }
                    if(orderMarginRate > 1.99 && orderMarginRate <= 2.49){
                        if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level2"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level2"] = salespersonMargin
                        else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level2"] += salespersonMargin
                    }
                    if(orderMarginRate > 2.49){
                        if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level3"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level3"] = salespersonMargin
                        else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins_level3"] += salespersonMargin
                    }

                    // ORDER DATE OFFICE MARGINS ALL
                    if(figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["officeMargins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["officeMargins"] = confirmedMargin
                    else figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["officeMargins"] += confirmedMargin
                    // ORDER DATE OFFICE MARGINS BY SALESPERSON
                    if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["officeMargins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["officeMargins"] = confirmedMargin
                    else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["officeMargins"] += confirmedMargin
                }

                // INVOICED ORDERED PRODUCTS MARGINS
                if(op.whenToInvoice && op.orderInvoiceStatus === 'invoiced'){
                    // REMOVE BEFORE AUGUST ORDERS

                    var created_at = null
                    if (o.created_at !== undefined && o.created_at.seconds !== undefined){
                        created_at = o.created_at
                    }
                    else if (o.created_at !== undefined && o.created_at.seconds === undefined) {
                        var seconds = new Date(o.created_at).getTime()/1000
                        created_at = {seconds}
                    }
                    var createdMonth = created_at.toDate().getMonth() +1
                    var createdYear = created_at.toDate().getFullYear()

                    //var createdMonth = o.created_at.toDate().getMonth() +1
                    //var createdYear = o.created_at.toDate().getFullYear()
                    if(createdYear < 2024  || (createdYear == 2024 && createdMonth < 8)) return
                    
                    
                    var whenToInvoice = null
                                    
                    if (op.whenToInvoice !== undefined && op.whenToInvoice.seconds !== undefined){
                        whenToInvoice = op.whenToInvoice
                    }
                    else if (op.whenToInvoice !== undefined && op.whenToInvoice.seconds === undefined) {
                        var seconds = new Date(op.whenToInvoice).getTime()/1000
                        whenToInvoice = {seconds}
                    }

                    if(!whenToInvoice) return
                    var invoicedMonth = whenToInvoice.toDate().getMonth() +1
                    var invoicedYear = whenToInvoice.toDate().getFullYear()

                    if(figuresByMonth[invoicedYear] === undefined) figuresByMonth[invoicedYear] = {}
                    if(figuresByMonth[invoicedYear][invoicedMonth] === undefined) figuresByMonth[invoicedYear][invoicedMonth] = {}
                    if(figuresByMonth[invoicedYear][invoicedMonth]["all"] === undefined) figuresByMonth[invoicedYear][invoicedMonth]["all"] = {}
                    if(figuresByMonth[invoicedYear][invoicedMonth][salesperson] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson] = {}

                    

                    //if(salesperson === 'CfssvG9CYWWCoLSkeoR6FVXy6K72' && invoicedYear === 2024 && invoicedMonth === 8 && total > 0) console.log({total,invoicedDay,invoicedMonth,invoicedYear})
                    if(figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedOfficeMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedOfficeMargins"] = confirmedMargin
                    else figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedOfficeMargins"] += confirmedMargin
                    if(figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedSalespersonMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedSalespersonMargins"] = salespersonMargin
                    else figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedSalespersonMargins"] += salespersonMargin
                    
                    if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins"] = confirmedMargin
                    else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins"] += confirmedMargin
                    if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins"] = salespersonMargin
                    else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins"] += salespersonMargin

                    
                    if(orderMarginRate <= 1.99){
                        if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level1"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level1"] = confirmedMargin
                        else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level1"] += confirmedMargin
                        if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level1"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level1"] = salespersonMargin
                        else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level1"] += salespersonMargin
                    }
                    if(orderMarginRate > 1.99 && orderMarginRate <= 2.49){
                        if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level2"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level2"] = confirmedMargin
                        else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level2"] += confirmedMargin
                        if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level2"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level2"] = salespersonMargin
                        else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level2"] += salespersonMargin
                        //console.log("ORDER MARGIN OVER 1.99 AND LESS THAN EQUAL TO 2.49")
                        /* if(op.salesperson === 'zNBbbWRgacVUU3TU06kTSLesn872' && confirmedMargin && invoicedMonth == 4 && invoicedYear == 2025){
                            console.log("HENRI 04 LASKUTETTTU TILAUS")
                            console.log(orderMarginRate, confirmedMargin)
                            if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level2"]) console.log("TOTAL:" ,figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level2"])
                        } */
                        
                    }
                    if(orderMarginRate > 2.49){
                        if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level3"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level3"] = confirmedMargin
                        else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins_level3"] += confirmedMargin
                        if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level3"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level3"] = salespersonMargin
                        else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins_level3"] += salespersonMargin
                    }
                    
                    //console.log("HERE3", invoicesAllPaidMonth,invoicesAllPaidYear,invoicesAllPaidWeek)
                }
            })

        }
        var year = selectedYear
        //var dataRestriction = this.dataRestriction
        // TABLE DATA
        if(chartType === "table") {
          console.log("FIGURES BY MONTH")
          console.log(figuresByMonth)  
          if (split === "salespersons"){
            //console.log(figuresByMonth)
            figures[year] === undefined ? figures[year] = [] : ""
            //var headers = this.generateTableHeaders(this.salesperson)
            Object.keys(figuresByMonth[year]).forEach(function(month,index){
              var data = []

              headers.forEach(header => {
                if(header.id === undefined) return
                
                if(figuresByMonth[year][month][header.id] !== undefined){
                  var salespersonMargins = figuresByMonth[year][month][header.id].margins !== undefined ? figuresByMonth[year][month][header.id].margins.toFixed(2) : 0
                  var salespersonMargins_level1 = figuresByMonth[year][month][header.id].margins_level1 !== undefined ? figuresByMonth[year][month][header.id].margins_level1.toFixed(2) : 0
                  var salespersonMargins_level2 = figuresByMonth[year][month][header.id].margins_level2 !== undefined ? figuresByMonth[year][month][header.id].margins_level2.toFixed(2) : 0
                  var salespersonMargins_level3 = figuresByMonth[year][month][header.id].margins_level3 !== undefined ? figuresByMonth[year][month][header.id].margins_level3.toFixed(2) : 0

                  var officeMargins = figuresByMonth[year][month][header.id].officeMargins !== undefined ? figuresByMonth[year][month][header.id].officeMargins.toFixed(2) : 0

                  
                  var invoicesAllPaidSalespersonMargins = figuresByMonth[year][month][header.id].invoicesAllPaidMargins !== undefined ? figuresByMonth[year][month][header.id].invoicesAllPaidMargins.toFixed(2) : 0
                  var invoicesAllPaidOfficeMargins = figuresByMonth[year][month][header.id].invoicesAllPaidOfficeMargins !== undefined ? figuresByMonth[year][month][header.id].invoicesAllPaidOfficeMargins.toFixed(2) : 0
                  
                  //var invoicedSalespersonMargins = figuresByMonth[year][month][header.id].invoicedMargins !== undefined ? figuresByMonth[year][month][header.id].invoicedMargins.toFixed(2) : 0
                  var invoicedOfficeMargins = figuresByMonth[year][month][header.id].invoicedOfficeMargins !== undefined ? figuresByMonth[year][month][header.id].invoicedOfficeMargins.toFixed(2) : 0
                  var invoicedSalespersonMargins = figuresByMonth[year][month][header.id].invoicedSalespersonMargins !== undefined ? figuresByMonth[year][month][header.id].invoicedSalespersonMargins.toFixed(2) : 0

                  var invoicedOfficeMargins_level1 = figuresByMonth[year][month][header.id].invoicedOfficeMargins_level1 !== undefined ? figuresByMonth[year][month][header.id].invoicedOfficeMargins_level1.toFixed(2) : 0
                  var invoicedSalespersonMargins_level1 = figuresByMonth[year][month][header.id].invoicedSalespersonMargins_level1 !== undefined ? figuresByMonth[year][month][header.id].invoicedSalespersonMargins_level1.toFixed(2) : 0

                  var invoicedOfficeMargins_level2 = figuresByMonth[year][month][header.id].invoicedOfficeMargins_level2 !== undefined ? figuresByMonth[year][month][header.id].invoicedOfficeMargins_level2.toFixed(2) : 0
                  var invoicedSalespersonMargins_level2 = figuresByMonth[year][month][header.id].invoicedSalespersonMargins_level2 !== undefined ? figuresByMonth[year][month][header.id].invoicedSalespersonMargins_level2.toFixed(2) : 0

                  var invoicedOfficeMargins_level3 = figuresByMonth[year][month][header.id].invoicedOfficeMargins_level3 !== undefined ? figuresByMonth[year][month][header.id].invoicedOfficeMargins_level3.toFixed(2) : 0
                  var invoicedSalespersonMargins_level3 = figuresByMonth[year][month][header.id].invoicedSalespersonMargins_level3 !== undefined ? figuresByMonth[year][month][header.id].invoicedSalespersonMargins_level3.toFixed(2) : 0

                  //console.log("-",year,month,header.id,invoicesAllPaidSalespersonMargins)
                  // CHECK FOR CUSTOM MARGIN SET
                  var customOfficeMargins = ''
                  /* console.log("monht", month)
                  if(staff[header.id].customMargins){
                    console.log(staff[header.id].customMargins)
                  } */

                  if(header.id && staff[header.id] && staff[header.id].customMargins && staff[header.id].customMargins[year] && staff[header.id].customMargins[year][month]){
                    customOfficeMargins = staff[header.id].customMargins[year][month]
                  }
                  var marginToShow = officeMargins
                  if(customOfficeMargins && (year < 2024 || (year === 2024 && month < 7))) marginToShow = customOfficeMargins
                  //if(customOfficeMargins) marginToShow = customOfficeMargins
                  //year > 2024 || (year == 2024 && props.index < 7)

                  var officeInvoiceMarginToShow = customOfficeMargins ? customOfficeMargins : invoicedOfficeMargins

                  // SIMPLIEFIED FROM 08/24 FORWARD FOR MARGINS
                  var margins = 'M: '+ salespersonMargins + ', O: ' + marginToShow
                  if((year > 2024 || (year === 2024 && month >= 8))) {
                    margins = salespersonMargins
                  }


                  if(dataRestriction === "none") 

                    data.push({
                      salespersonId:header.id,
                      margins,
                      marginsSalesperson:salespersonMargins,
                      marginsSalesperson_level1:salespersonMargins_level1,
                      marginsSalesperson_level2:salespersonMargins_level2,
                      marginsSalesperson_level3:salespersonMargins_level3,
                      originalOfficeMargin: officeMargins,
                      invoicedMargins: 'M: '+invoicedSalespersonMargins + ', O: ' + officeInvoiceMarginToShow,
                      invoicedMarginsSalesperson: invoicedSalespersonMargins,
                      invoicedMarginsSalesperson_level1:invoicedSalespersonMargins_level1,
                      invoicedMarginsSalesperson_level2:invoicedSalespersonMargins_level2,
                      invoicedMarginsSalesperson_level3:invoicedSalespersonMargins_level3,
                      invoicedMarginsOffice:officeInvoiceMarginToShow,
                      invoicedMarginsOffice_level1:invoicedOfficeMargins_level1,
                      invoicedMarginsOffice_level2:invoicedOfficeMargins_level2,
                      invoicedMarginsOffice_level3:invoicedOfficeMargins_level3,
                      originalOfficeInvoicedMargins:invoicedOfficeMargins,
                      customOfficeMargins:customOfficeMargins,
                      invoicesAllPaidMargins: 'M: '+ invoicesAllPaidOfficeMargins+', O:' + invoicesAllPaidSalespersonMargins
                    })
                  else 
                    if(dataRestriction === header.id) {
                      data.push({
                        salespersonId:header.id,
                        margins,
                        marginsSalesperson:salespersonMargins,
                        marginsSalesperson_level1:salespersonMargins_level1,
                        marginsSalesperson_level2:salespersonMargins_level2,
                        marginsSalesperson_level3:salespersonMargins_level3,
                        originalOfficeMargin: officeMargins,
                        invoicedMargins: 'M: '+invoicedSalespersonMargins + ', O: ' + officeInvoiceMarginToShow,
                        invoicedMarginsSalesperson: invoicedSalespersonMargins,
                        invoicedMarginsSalesperson_level1:invoicedSalespersonMargins_level1,
                        invoicedMarginsSalesperson_level2:invoicedSalespersonMargins_level2,
                        invoicedMarginsSalesperson_level3:invoicedSalespersonMargins_level3,
                        invoicedMarginsOffice:officeInvoiceMarginToShow,
                        invoicedMarginsOffice_level1:invoicedOfficeMargins_level1,
                        invoicedMarginsOffice_level2:invoicedOfficeMargins_level2,
                        invoicedMarginsOffice_level3:invoicedOfficeMargins_level3,
                        originalOfficeInvoicedMargins:invoicedOfficeMargins,
                        customOfficeMargins:customOfficeMargins,
                        invoicesAllPaidMargins: 'M: '+ invoicesAllPaidOfficeMargins+', O:' + invoicesAllPaidSalespersonMargins
                      })
                    }
                }
                else {
                  data.push(0)
                }
              })
              figures[year].push(data)
            })
            return figures[year]
          }

        }
    },
    getRange(ranges,quantity){
        var matchedProductPriceRange = null
        var lowestRangeId = null
        var highestRangeId = null
        var lowestRange = 1000
        var highestRange = 0
        var q = Number(quantity)
        var rangesKeys = [1,2,3,4,5,6,7,8,9,10,11,12]
        rangesKeys.forEach(rId => {
            if(!ranges[rId]) return
            //console.log(ranges[rId])
            var r = ranges[rId]
            var end = Number(r.end)
            if(r.start === '') return
            var start = Number(r.start)

            if(r.start && r.start.trim() === '--'){
                //console.log(rId)
                matchedProductPriceRange = rId
            }
            else if(!matchedProductPriceRange && q >= start && q <= end ){
                matchedProductPriceRange = rId
            }
            //if(!lowestRangeId) {lowestRangeId = rId;lowestRange=start}
            //if(!highestRangeId) {highestRangeId = rId;highestRange=end}
            if(start > highestRange) {highestRangeId = rId;highestRange=start}
            if(end > highestRange) {highestRangeId = rId;highestRange=end}
            if(start < lowestRange) {lowestRangeId = rId;lowestRange=start}
            //if(end < lowestRange) {lowestRangeId = rId;lowestRange=end}

        })
        //console.log({lowestRange,highestRange,matchedProductPriceRange})
        if(!matchedProductPriceRange && quantity < lowestRange) matchedProductPriceRange = lowestRangeId
        if(!matchedProductPriceRange && quantity > highestRange) matchedProductPriceRange = highestRangeId


        return matchedProductPriceRange
    },
    formatToThreeDecimals(number){
        if(isNaN(Number(number))) return 0
        else {
            var val = Number(number)
            val = val.toFixed(3)
            val = Number(val)
            return val
        }
    },
    
}


// WEBPACK FOOTER //
// ./src/shared.js